import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Delivery() {
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />

      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Shipping & Delivery</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p>
              <strong>Shipping Information</strong>
            </p>
            <p>
              We are committed to getting your Bernicemy purchase to you as
              quickly and efficiently as possible. We offer several shipping
              options to meet your needs.
            </p>
            <p>
              <strong>Domestic Shipping (United States)</strong>
            </p>
            <p>We offer the following shipping options for domestic orders:</p>
            <ul>
              <li>
                <strong>Standard Shipping (5-7 Business Days):</strong> $10.00 -
                Free on orders over $200
              </li>
              <li>
                <strong>Express Shipping (2-3 Business Days):</strong> $25.00
              </li>
              <li>
                <strong>Overnight Shipping (1 Business Day):</strong> $40.00
              </li>
            </ul>
            <p>
              <strong>Processing Time</strong>
            </p>
            <p>
              Orders are typically processed and shipped within 1-2 business
              days. Please note that processing time does not include shipping
              time. Orders placed after 12:00 PM EST will be processed the
              following business day. We do not process orders on weekends or
              holidays.
            </p>
            <p>
              <strong>International Shipping</strong>
            </p>
            <p>
              We are pleased to offer international shipping to select
              countries. International shipping rates and delivery times vary by
              destination. Please note:
            </p>
            <ul>
              <li>International shipping rates start at $35.00</li>
              <li>Delivery typically takes 7-14 business days</li>
              <li>
                Customers are responsible for all customs duties, taxes, and
                fees
              </li>
              <li>
                These charges are not included in your order total and will be
                collected upon delivery
              </li>
            </ul>
            <p>
              <strong>Order Tracking</strong>
            </p>
            <p>
              Once your order ships, you will receive a shipping confirmation
              email with tracking information. You can track your package using
              the tracking number provided. If you have any questions about your
              shipment, please contact our customer service team.
            </p>
            <p>
              <strong>Buy Online, Pick Up In Store</strong>
            </p>
            <p>
              For your convenience, we offer buy online and pick up in store at
              select Billy Reid locations. Simply select your preferred store at
              checkout. Most orders are ready for pickup within 2-3 hours during
              regular business hours. You will receive an email notification
              when your order is ready.
            </p>
            <p>
              <strong>Shipping Restrictions</strong>
            </p>
            <p>Please note the following shipping restrictions:</p>
            <ul>
              <li>
                We do not ship to P.O. boxes for express or overnight delivery
              </li>
              <li>We do not ship to freight forwarders</li>
              <li>
                Some items may have shipping restrictions to certain locations
              </li>
            </ul>
            <p>
              <strong>Shipping to Multiple Addresses</strong>
            </p>
            <p>
              If you would like to ship items to multiple addresses, you will
              need to place separate orders for each shipping address.
            </p>
            <p>
              <strong>Lost or Damaged Shipments</strong>
            </p>
            <p>
              If your package is lost or arrives damaged, please contact us
              immediately at{" "}
              <a href="mailto:shop@bernicemy.blog">shop@bernicemy.blog</a>. We
              will work with the carrier to resolve the issue and ensure you
              receive your items.
            </p>
            <p>
              <strong>Holiday Shipping</strong>
            </p>
            <p>
              During peak holiday seasons, we recommend ordering early to ensure
              timely delivery. Please check our website for specific holiday
              shipping deadlines and cutoff dates.
            </p>
            <p>
              <strong>Contact Us</strong>
            </p>
            <p>
              If you have any questions about shipping, please contact our
              customer service team:
            </p>
            Bernicemy, Inc. <br />
            114 North Court Street <br />
            Florence, AL 35630 <br />
            USA <br />
            <br />
            Email: <a href="mailto:shop@bernicemy.blog">
              shop@bernicemy.blog
            </a>{" "}
            <br />
            Phone: 1-877-757-3934 <br />
            Hours: Monday - Friday, 9:00 AM - 5:00 PM EST
          </div>
        </div>
      </div>

      <Footer />
    </body>
  );
}

export default Delivery;
